import React from 'react';

const Card = ({ title, subtitle, type, onClick }) => {
  return (
    <div className={`bg-white border border-gray-200 rounded-lg p-5 flex flex-col items-start`}>
      <span className="flex text-left text-sm text-white font-semibold p-2 bg-primary-500 rounded-full">
        {type.toUpperCase()}
      </span>
      <h5 className="text-xl font-bold tracking-tight text-left my-2">{title}</h5>
      <h5 className="text-base tracking-tight text-left">{subtitle}</h5>
    </div>
  );
};

export default Card;
